var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLavender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74804 4.82042C9.74804 6.09902 8.73974 7.13553 7.49593 7.13553C6.25213 7.13553 5.24383 6.09902 5.24383 4.82042C5.24383 3.5418 6.25213 2.5053 7.49593 2.5053C8.73974 2.50529 9.74804 3.54181 9.74804 4.82042ZM7.5 0C6.21219 0.0061294 4.87733 0.342522 3.6137 0.986565C2.67548 1.48445 1.76112 2.18691 0.967425 3.05394C0.5776 3.49653 0.0803875 4.1374 0 4.82117C0.0095 5.41347 0.601625 6.14454 0.967425 6.58841C1.71171 7.42139 2.60225 8.10423 3.6137 8.65629C4.79209 9.26992 6.0964 9.62321 7.5 9.64286C8.78904 9.63663 10.1236 9.29637 11.3858 8.65629C12.3241 8.1584 13.2389 7.45544 14.0326 6.58841C14.4224 6.14582 14.9196 5.50494 15 4.82117C14.9905 4.22887 14.3984 3.49777 14.0326 3.05392C13.2883 2.22093 12.3973 1.53861 11.3858 0.986538C10.2081 0.373384 8.90053 0.0225192 7.5 0ZM7.49905 1.19702C9.45054 1.19702 11.0325 2.81982 11.0325 4.82169C11.0325 6.82355 9.45054 8.44635 7.49905 8.44635C5.54756 8.44635 3.96561 6.82354 3.96561 4.82169C3.96561 2.81982 5.54756 1.19702 7.49905 1.19702Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLavender);
export default __webpack_public_path__ + "static/media/eye-lavender.b4147cebde9e5b0b2649a96ef1cede5c.svg";
export { ForwardRef as ReactComponent };